export default __webpack_public_path__ + "images/red-wine.png";